interface TooltipProps {
  content: string;
  children: React.ReactNode;
  className?: string;
}

export function Tooltip({ content, children, className }: TooltipProps) {
  return (
    <div className={`group relative inline-block ${className}`}>
      {children}
      <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity absolute z-50 bottom-full mb-2 left-1/2 -translate-x-1/2">
        <div className="bg-dualite-background-secondary text-dualite-text-primary text-xs px-3 py-1.5 rounded-md border border-dualite-border-primary">
          {content}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-[2px]">
            <div className="border-4 border-transparent border-t-dualite-border-primary" />
          </div>
        </div>
      </div>
    </div>
  );
}
